import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { Label, VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import I18n from 'i18n-js';
import { split as _split, find as _find } from 'lodash';
import PropTypes from 'prop-types';

import { Images } from '../../../Themes';
import LoginTestKeys from '../../../Utils/LoginTestKeys';
import styles from '../AuthContainer.Styles';

function Labels({
  firstLabelTitle,
  withFirstLabel,
  firstLabelOnPress,
  firstLabelDisabled,
  firstLabelAccessibilityLabel,
  firstLabelTestID,
  secondLabelTitle,
  withSecondLabel,
  secondLabelOnPress,
  secondLabelDisabled,
  secondLabelAccessibilityLabel,
  secondLabelTestId,
  thirdLabelTitle,
  withThirdLabel,
  thirdLabelTitleText,
  thirdLabelOnPress,
  thirdLabelDisabled,
  withChangeLanguage,
  onPressLanguageLabel,
  languageProps,
}) {
  const placeholder = '%1$s';
  const thirdTextTranslatedKey = ContentManager.translate(thirdLabelTitleText || '', [placeholder]);
  const thridTextSplitted = _split(thirdTextTranslatedKey, placeholder);

  return (
    <>
      {firstLabelTitle && withFirstLabel && (
        <Label
          title={firstLabelTitle}
          style={styles.firstLabel}
          textStyle={styles.firstLabelTextStyle}
          onPress={firstLabelOnPress}
          disabled={firstLabelDisabled}
          textAccessibilityLabel={firstLabelAccessibilityLabel}
          secondLabelTestId={firstLabelTestID}
        />
      )}
      {secondLabelTitle && withSecondLabel && (
        <Label
          title={secondLabelTitle}
          style={styles.secondLabel}
          textStyle={styles.labelTextStyle}
          onPress={secondLabelOnPress}
          disabled={secondLabelDisabled}
          textAccessibilityLabel={secondLabelAccessibilityLabel}
          secondLabelTestId={secondLabelTestId}
        />
      )}
      {thirdLabelTitle && withThirdLabel && (
        <View style={styles.thirdLabelContainer}>
          <View style={styles.thirdLabel}>
            <VFText
              localize={false}
              style={styles.thirdLabelTextStyle}
              i18nKey={thridTextSplitted[0]}
            />
          </View>
          <Label
            title={thirdLabelTitle}
            style={styles.thirdLabel}
            textStyle={styles.labelTextStyle}
            onPress={thirdLabelOnPress}
            disabled={thirdLabelDisabled}
          />
        </View>
      )}
      {withChangeLanguage && (
        <View style={styles.langContainer}>
          <View style={styles.langDivider} testID={LoginTestKeys.loginLanguageDivider} />
          <View style={styles.changeLangContainer}>
            <Icon type="image" source={Images.ic_language} size={26} style={styles.langIcon} />
            <TouchableOpacity
              style={styles.labelStyle}
              onPress={onPressLanguageLabel}
              accessible={false}
            >
              <VFText i18nKey={'login_change_language_label'} style={styles.labelTextStyle} />
              <VFText style={styles.labelTextStyle} i18nKey={':'} />
            </TouchableOpacity>
            <View>
              <VFText
                style={styles.changeLangTextStyle}
                i18nKey={
                  _find(languageProps?.languages, ['identifier', I18n.currentLocale()])?.title
                }
              />
            </View>
          </View>
        </View>
      )}
    </>
  );
}

Labels.defaultProps = {
  firstLabelTitle: null,
  withFirstLabel: true,
  secondLabelTitle: null,
  withSecondLabel: true,
  thirdLabelTitle: null,
  withThirdLabel: false,
};

Labels.propTypes = {
  firstLabelTitle: PropTypes.string,
  withFirstLabel: PropTypes.bool,
  firstLabelOnPress: PropTypes.func,
  firstLabelDisabled: PropTypes.bool,
  firstLabelAccessibilityLabel: PropTypes.string,
  firstLabelTestID: PropTypes.string,
  secondLabelTitle: PropTypes.string,
  withSecondLabel: PropTypes.bool,
  secondLabelOnPress: PropTypes.func,
  secondLabelDisabled: PropTypes.bool,
  secondLabelAccessibilityLabel: PropTypes.string,
  secondLabelTestId: PropTypes.string,
  thirdLabelTitle: PropTypes.string,
  withThirdLabel: PropTypes.bool,
  thirdLabelTitleText: PropTypes.string,
  thirdLabelOnPress: PropTypes.func,
  thirdLabelDisabled: PropTypes.bool,
  withChangeLanguage: PropTypes.bool,
  onPressLanguageLabel: PropTypes.func,
  languageProps: PropTypes.object,
};

export default Labels;
